import React, {
  useEffect, useRef,
} from 'react';

import { useGenericFieldsDataAdopted } from 'containers/FormDataAdapter';
import { IFormValues } from 'common/components/FormHF/types';

import { ARGProjectFields } from '@arg,@demo,@greenline/containers/project-fields';
import { TranslationKey } from '@arg,@demo/utils/text-translations';
import { useCssVariables } from 'utils/css-variables';
import { useSummary } from './useSummary';

import { DocumentTemplate } from './printer';
import { useTranslateFn } from '../../../utils/useTranslateFn';


const PrintView = () => {
  const t = useTranslateFn<TranslationKey>();
  const summary = useSummary();
  // Note: useMemo fails for some reason
  const cssVariablesRaw = useCssVariables();
  const pdfText = DocumentTemplate(summary, summary.quantity, t, cssVariablesRaw);
  const div = useRef<HTMLDivElement>(null);

  useEffect(
    () => {
      const images = div.current?.querySelectorAll('img');
      if (images && images.length > 0) {
        // wait for all images to load or error
        const promises = Array.from(images).map((img) => new Promise((resolve) => {
          img.addEventListener('load', resolve);
          img.addEventListener('error', resolve);
        }));
        Promise.all(promises).then(() => {
          (window as any).printReady = true;
        });
      } else {
        (window as any).printReady = true;
      }
    },
    [],
  );

  return <div className="print" ref={div} dangerouslySetInnerHTML={{ __html: pdfText }} />;
};

const PrintLoader = () => {
  const { isLoading } = useGenericFieldsDataAdopted<IFormValues<ARGProjectFields>>();
  if (!isLoading) {
    return <PrintView />;
  }
  return null;
};

// @ts-ignore
export default PrintLoader;
